import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import { RcQuotesStyles } from './BackOfficeVehicleQuotes.styles';
import LambdaLoaderCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/LambdaLoaderCard';
import {
  addQuoteToCartAutoBackOffice,
  checkScrapperResultsAutoBackoffice,
  loadAutoQuotes,
  removeQuoteAutoFromCart,
  resetAutoQuotes,
  updateAutoQuotesData,
} from '../../../features/backofficeResults/backofficeResultsActions';
import { Layout } from '../components/Layout/Layout';
import { AvvisoAlert } from '../../RcQuotes.styles';
import GuaranteesModal from '../components/common/Modal/GuaranteesModal';
import { coveragesUtil } from '../../../utils/coverages';
import { primaQuoteTypes, primaMergeQuoteTypes } from '../../../common/constants';
import { confirmAlert } from '../../../common/utils/alerts';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import VehicleSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/VehicleSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  RiskCard,
  RiskContainer,
} from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
import { updateSortByAuto } from '../../../features/insuranceRequests/insuranceRequestsActions';
import ModalQuotesBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/ModalQuotesBackoffice';
import SelectedQuotesCardsBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/SelectedQuotesCardsBackoffice';
import ButtonComponentLogicBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/ButtonComponentLogicBackoffice';
import {
  riskCardPrimaStyles,
  riskCardStyles,
} from '../../../common/components/redesignComponents/ResultPageComponents/RcQuotesModal.style';
import ModalQuotesPrimaBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/ModalQuotesPrimaBackoffice';
import ButtonComponentLogicPrimaBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/ButtonComponentLogicPrimaBackoffice';
import SelectedQuotesCardsPrimaBackoffice from '../../../common/components/redesignComponents/ResultPageComponents/SelectedQuotesCardsPrimaBackoffice';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import FailedQuotationsComponent from '../../../common/components/redesignComponents/ResultPageComponents/v2/FailedQuotationsComponent';

function BackOfficeVehicleQuotes() {
  // const navigate = useNavigate();
  const { requestToken } = useParams();
  const clearQuotesIntervalRef = useRef(null);
  const requestInfoRef = useRef(null);
  const checkResultsIntervalRef = useRef(null);
  const isPollingStartedRef = useRef(false);
  const [showGuaranteesModal, setShowGuaranteesModal] = useState(false);
  const [intervalQuotes, setIntervalQuotes] = useState(null);
  const [allScrapperResulsGotten, setAllScrapperResulsGotten] = useState({
    genial_received: false,
    verti_received: false,
    linear_received: false,
    nobis_received: false,
  });
  const state = useSelector((store) => store.backofficeResults.auto_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    failedQuotes,
    processingQuote,
    quotations,
    addingQuote,
    sortBy,
    preventivas_quotes,
    riskQuotes,
  } = state;

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const [counter, setCounter] = useState(180);
  const [currentQuotes, setCurrentQuotes] = useState('diretta');

  const handleCurrentQuotesDisplay = (val) => {
    setCurrentQuotes(val);
  };

  const guaranteesPrima = (quote) => {
    const guarantees = quote.quotation_data_prima_guarantees
      .map((guarantee) => guarantee.slug)
      .filter((g) => g != 'rca' && g != 'furto_incendio');
    if (
      quote.quotation_data_prima_guarantees.find(
        (qg) => qg.slug == 'furto_incendio',
      ) != undefined
    ) {
      guarantees.push('incendio');
      guarantees.push('furto');
    }
    return guarantees;
  };

  // const modifyData = () => {
  //   if (requestInfo.product_id == 1) {
  //     navigate(`/backoffice/quote/${requestToken}/auto`);
  //   } else {
  //     navigate(`/backoffice/quote/${requestToken}/autocarro`);
  //   }
  // };

  useEffect(() => {
    if (quoteTypes.length === 0) {
      getQuoteTypes();
    }
  }, [quoteTypes]);

  useEffect(() => {
    loadAutoQuotes(requestToken);

    return () => {
      resetAutoQuotes();
    };
  }, []);

  const clearQuotesInterval = () => {
    if (intervalQuotes !== null) {
      clearInterval(intervalQuotes);
      setIntervalQuotes(null);
    }
  };

  clearQuotesIntervalRef.current = clearQuotesInterval;
  requestInfoRef.current = requestInfo;

  const sortQuotes = (sortBy) => {
    updateSortByAuto(sortBy);
  };

  const refresh = () => loadAutoQuotes(requestToken);

  const checkScrapperResponses = async () => {
    const data = await checkScrapperResultsAutoBackoffice(requestInfo.id);
    if (!data) return false;

    setAllScrapperResulsGotten({
      genial_received: data.genial_received,
      verti_received: data.verti_received,
      linear_received: data.linear_received,
      nobis_received: data.nobis_received,
    });

    if (requestInfo.product_id == 1) {
      if (data.genial_received || data.verti_received || data.linear_received || data.nobis_received) {
        loadAutoQuotes(requestToken);
      }
    } else if (data.genial_received || data.linear_received || data.verti_received) {
      loadAutoQuotes(requestToken);
    }

    return data.received_all;
  };

  useEffect(() => {
    const iq = setInterval(() => {
      const requestInfo = requestInfoRef.current;
      if (requestInfo !== null && requestInfo.product_id == 1) {
        if (requestInfo.with_preventivas === null) {
          loadAutoQuotes(requestToken);
        }

        if (requestInfo.with_preventivas !== null) {
          clearQuotesIntervalRef.current();
        }
      }
    }, 10000);

    setIntervalQuotes(iq);

    return () => {
      clearQuotesIntervalRef.current();
    };
  }, []);

  useEffect(() => {
    if (requestInfo !== null && requestInfo.quotations) {
      updateAutoQuotesData(requestInfo);
    }
  }, [requestInfo]);

  useEffect(() => {
    if (!requestInfo?.id) return undefined;

    isPollingStartedRef.current = false;

    if (checkResultsIntervalRef.current) {
      clearInterval(checkResultsIntervalRef.current);
      checkResultsIntervalRef.current = null;
    }

    const initializePolling = async () => {
      const allReceived = await checkScrapperResponses();

      if (!isPollingStartedRef.current && !allReceived) {
        isPollingStartedRef.current = true;

        checkResultsIntervalRef.current = setInterval(async () => {
          const allReceivedInInterval = await checkScrapperResponses();
          if (allReceivedInInterval && checkResultsIntervalRef.current) {
            clearInterval(checkResultsIntervalRef.current);
            checkResultsIntervalRef.current = null;
            isPollingStartedRef.current = false;
          }
        }, 5000);
      }
    };

    initializePolling();

    return () => {
      if (checkResultsIntervalRef.current) {
        clearInterval(checkResultsIntervalRef.current);
        checkResultsIntervalRef.current = null;
        isPollingStartedRef.current = false;
      }
    };
  }, [requestInfo?.id]);

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  if (loading) {
    return <PageLoading />;
  }

  const coverages = coveragesUtil.calculateCommonCoverages(
    requestInfo?.product_id ?? 1,
    quotes ?? [],
  );

  const fetchQuotes = () => {
    loadAutoQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addQuoteToCartAutoBackOffice(quoteId, fetchQuotes));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeQuoteAutoFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;
    let primaGuaranteesPrices = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotes && riskQuotes[type.id] !== undefined) {
        for (let i = 0; i < riskQuotes[type.id].length; i++) {
          const item = riskQuotes[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    if (processingQuote !== null && processingQuote.company_id === 2) {
      processingQuote.guarantees.forEach((guarantee) => {
        primaGuaranteesPrices += parseFloat(guarantee.amount) || 0;
      });
    }

    return (
      quoteInProccessAmount
      + primaGuaranteesPrices
      + risksTotalAmount
    ).toFixed(2);
  };

  // const handleRequestSave = () => {
  //   if (processingQuote === null) {
  //     generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
  //     return;
  //   }

  //   if (requestInfo.product_id == 1) {
  //     navigate(`/quotes/auto/purchase/${requestToken}`);
  //   } else if (requestInfo.product_id == 3) {
  //     navigate(`/quotes/autocarro/purchase/${requestToken}`);
  //   }
  // };

  return (
    <Layout>
      {showGuaranteesModal && (
        <GuaranteesModal
          setShowGuaranteesModal={setShowGuaranteesModal}
          coverages={coverages}
          requestToken={requestToken}
        />
      )}

      <V2FontImport />
      <RcQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <VehicleSummaryCard
              insuranceRequest={requestInfo}
            // modificaDati={modifyData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotes}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
            />
          </ResultOverviewRow>

          {/* <div className="row">
            <div className="col-12">
              <EstimateContainer>
                <h4>
                  Preventivi assicurazione
                  {' '}
                  <b>
                    {requestInfo.product_id == '1' && 'auto'}
                    {' '}
                    {requestInfo.product_id == '3' && 'autocarro'}
                  </b>
                </h4>
                <p>
                  Inizio Copertura:
                  {' '}
                  {requestInfo.vehicle !== null
                    && new Date(
                      requestInfo.policy_effective_date,
                    ).toLocaleDateString('it-IT', {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    })}
                  <br />
                </p>
              </EstimateContainer>
            </div>
          </div> */}

          {requestInfo && requestInfo.product_id == 1 && (
            <>
              {(allScrapperResulsGotten.genial_received === false || allScrapperResulsGotten.verti_received === false || allScrapperResulsGotten.nobis_received === false) && (
                <div className="row my-3">
                  <div className="col-12">
                    <LambdaLoaderCard />
                  </div>
                </div>
              )}
            </>
          )}

          {requestInfo && requestInfo.product_id == 3 && (
            <>
              {(allScrapperResulsGotten.genial_received === false || allScrapperResulsGotten.linear_received === false || allScrapperResulsGotten.verti_received === false) && (
                <div className="row my-3">
                  <div className="col-12">
                    <LambdaLoaderCard />
                  </div>
                </div>
              )}
            </>
          )}

          {quotations && !quotations.res_civile
            && (
              <AvvisoAlert role="alert">
                <h4>Avviso!</h4>
                <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </AvvisoAlert>
            )}

          <RiskContainer className="mb-4 result-profession-fourth-step">
            {processingQuote !== null && processingQuote.company_id === 2
              ? [{ id: 'res_civile', name: 'Responsabilita Civile' }].map(
                (type) => (
                  <>
                    {quotations && quotations[type.id] && (
                      <RiskCard
                        className={riskCardStyles(
                          requestInfo,
                          type,
                          riskQuotes,
                        )}
                      >
                        <div className="me-auto">
                          <h5>{type.name}</h5>
                        </div>
                        <SelectedQuotesCardsBackoffice
                          processingQuote={processingQuote}
                          type={type}
                          refresh={refresh}
                          requestInfo={requestInfo}
                          riskQuotations={riskQuotes}
                        />

                        <ButtonComponentLogicBackoffice
                          type={type}
                          processingQuote={processingQuote}
                          removeItemFromCart={removeItemFromCart}
                          requestInfo={requestInfo}
                          riskQuotations={riskQuotes}
                        />
                      </RiskCard>
                    )}
                  </>
                ),
              )
              : quoteTypes.map((type) => (
                <>
                  {quotations && quotations[type.id] && (
                    <RiskCard
                      className={riskCardStyles(
                        requestInfo,
                        type,
                        riskQuotes,
                      )}
                    >
                      <div className="me-auto">
                        <h5>{type.name}</h5>
                      </div>
                      <SelectedQuotesCardsBackoffice
                        processingQuote={processingQuote}
                        type={type}
                        refresh={refresh}
                        requestInfo={requestInfo}
                        riskQuotations={riskQuotes}
                      />

                      <ButtonComponentLogicBackoffice
                        type={type}
                        processingQuote={processingQuote}
                        removeItemFromCart={removeItemFromCart}
                        requestInfo={requestInfo}
                        riskQuotations={riskQuotes}
                      />
                    </RiskCard>
                  )}
                </>
              ))}

            {processingQuote !== null && processingQuote.company_id === 2 && (
              <>
                {processingQuote.quotation_data_prima.quotation_data_prima_guarantees.map(
                  (quote) => {
                    if (quote.slug === 'rca') return null;

                    // If a Nobis alternative is the one actually selected for
                    // this guarantee (picked from this same card's own modal),
                    // render the merge card here, in place of Prima's own
                    // (unselected) catalog card, so the risk stays in the same
                    // list position instead of jumping to the end.
                    const mergeMatch = primaMergeQuoteTypes.find(
                      (m) => m.primaSlug === quote.slug,
                    );
                    const isActiveInPrima = processingQuote.guarantees?.some(
                      (g) => g.guarantees_slug === quote.slug,
                    );
                    const nobisSelectedInstead = mergeMatch
                      && !isActiveInPrima
                      && Array.isArray(riskQuotes?.[mergeMatch.id])
                      && riskQuotes[mergeMatch.id].some((q) => q.company_id === 1001);

                    if (nobisSelectedInstead) {
                      const mergeType = quoteTypes.find((t) => t.id === mergeMatch.id);
                      if (!mergeType) return null;

                      return (
                        <RiskCard
                          key={quote.slug}
                          className={riskCardStyles(requestInfo, mergeType, riskQuotes)}
                        >
                          <div className="me-auto">
                            <h5>{mergeType.name}</h5>
                          </div>
                          <SelectedQuotesCardsBackoffice
                            processingQuote={processingQuote}
                            type={mergeType}
                            refresh={refresh}
                            requestInfo={requestInfo}
                            riskQuotations={riskQuotes}
                          />
                          <ButtonComponentLogicBackoffice
                            type={mergeType}
                            processingQuote={processingQuote}
                            removeItemFromCart={removeItemFromCart}
                            requestInfo={requestInfo}
                            riskQuotations={riskQuotes}
                          />
                        </RiskCard>
                      );
                    }

                    const primaType = primaQuoteTypes.find((t) => t.id === quote.slug);

                    return (
                      <RiskCard
                        key={quote.slug}
                        className={riskCardPrimaStyles(primaType, processingQuote)}
                      >
                        <div className="me-auto">
                          <h5>{primaType.name}</h5>
                        </div>
                        <SelectedQuotesCardsPrimaBackoffice
                          processingQuote={processingQuote}
                          type={primaType}
                        />

                        <ButtonComponentLogicPrimaBackoffice
                          type={primaType}
                          processingQuote={processingQuote}
                          requestInfo={requestInfo}
                        />
                      </RiskCard>
                    );
                  },
                )}

                {primaMergeQuoteTypes.map((mergeType) => {
                  // This only handles merge types that never appear in Prima's
                  // own catalog above at all (primaSlug === null, e.g.
                  // ricordo_terzi_da_incendio, or a slug this quote's Prima
                  // catalog doesn't list) — types with a catalog entry are
                  // already handled in place, in the loop above.
                  const catalogEntryExists = mergeType.primaSlug !== null
                    && processingQuote.quotation_data_prima
                      ?.quotation_data_prima_guarantees?.some(
                        (g) => g.slug === mergeType.primaSlug,
                      );
                  if (catalogEntryExists) return null;

                  const coveredByPrima = mergeType.primaSlug !== null
                    && processingQuote.guarantees?.some(
                      (g) => g.guarantees_slug === mergeType.primaSlug,
                    );
                  if (coveredByPrima) return null;

                  const hasNobisQuote = Array.isArray(quotations?.[mergeType.id])
                    && quotations[mergeType.id].some((q) => q.company_id === 1001);
                  if (!hasNobisQuote) return null;

                  const type = quoteTypes.find((t) => t.id === mergeType.id);
                  if (!type) return null;

                  return (
                    <RiskCard
                      key={mergeType.id}
                      className={riskCardStyles(requestInfo, type, riskQuotes)}
                    >
                      <div className="me-auto">
                        <h5>{type.name}</h5>
                      </div>
                      <SelectedQuotesCardsBackoffice
                        processingQuote={processingQuote}
                        type={type}
                        refresh={refresh}
                        requestInfo={requestInfo}
                        riskQuotations={riskQuotes}
                      />
                      <ButtonComponentLogicBackoffice
                        type={type}
                        processingQuote={processingQuote}
                        removeItemFromCart={removeItemFromCart}
                        requestInfo={requestInfo}
                        riskQuotations={riskQuotes}
                      />
                    </RiskCard>
                  );
                })}
              </>
            )}
          </RiskContainer>

          {quoteTypes.map((type, index) => (
            <ModalQuotesBackoffice
              processingQuote={processingQuote}
              key={index}
              type={type}
              addingQuote={addingQuote}
              sortBy={sortBy}
              sortQuotes={sortQuotes}
              handleCurrentQuotesDisplay={handleCurrentQuotesDisplay}
              currentQuotes={currentQuotes}
              requestInfo={requestInfo}
              counter={counter}
              quotations={quotations}
              requestToken={requestToken}
              riskQuotes={riskQuotes}
              refresh={refresh}
              selectQuotation={selectQuotation}
              guaranteesPrima={guaranteesPrima}
              preventivas_quotes={preventivas_quotes}
            />
          ))}

          {processingQuote !== null
            && processingQuote.company_id === 2
            && primaQuoteTypes.map((type, index) => (
              <ModalQuotesPrimaBackoffice
                processingQuote={processingQuote}
                key={index}
                type={type}
                addingQuote={addingQuote}
                sortBy={sortBy}
                sortQuotes={sortQuotes}
                requestInfo={requestInfo}
                requestToken={requestToken}
                guaranteesPrima={guaranteesPrima}
                quotations={quotations}
                selectQuotation={selectQuotation}
                riskQuotations={riskQuotes}
              />
            ))}

          {/* <div className="row mb-4">
            <div className="d-flex align-items-center justify-content-center gap-2 mb-3">
              <button className={`btn ${currentQuotes === 'diretta' ? 'btn-success' : 'btn-outline-success'}`} onClick={() => handleCurrentQuotesDisplay('diretta')}>Compagnie Dirette</button>
              <button className={`btn ${currentQuotes === 'indiretta' ? 'btn-success' : 'btn-outline-success'}`} onClick={() => handleCurrentQuotesDisplay('indiretta')}>Compagnie Indirette</button>
            </div>
            {(requestInfo.product_id == 1 && requestInfo.with_preventivas === null) && (
              <div className="d-flex align-items-center justify-content-center mb-2">
                <QuoteLoader>{counter}</QuoteLoader>
                {' '}
                <span className="ms-2">Recuperando più preventivi...</span>
              </div>
            )}
            {quotes && (currentQuotes === 'diretta' || currentQuotes === 'indiretta') && quotes.map((quote) => (
              currentQuotes === 'diretta' ? (
                <>
                  {quote.company_id === 1
                    && (
                      <div className="col-12 mb-2" key={quote.id}>
                        <AdriaticCard requestToken={requestToken} requestInfo={requestInfo} key={quote.id} quote={quote.quotation_data_adriatic} quotation={quote} company={quote.company} saved_quote={quote.saved_quotation} refresh={refresh} />
                      </div>
                    )}
                  {quote.company_id === 2
                    && (
                      <div className="col-12 mb-2" key={quote.id}>
                        <PrimaCard requestToken={requestToken} requestInfo={requestInfo} key={quote.id} quotation={quote} saved_quote={quote.saved_quotation} guaranteesPrima={guaranteesPrima} quotationAquistaLoading={quotationAquistaLoading} refresh={refresh} />
                      </div>
                    )}
                  {(quote.company_id === 9 || quote.company_id === 10)
                    && (
                      <div className="col-12 mb-2">
                        <PreventivassCardLinearAndDallbogg requestInfo={requestInfo} quotation={quote} refresh={refresh} />
                      </div>
                    )}
                  {quote.company_id === null && quote.added_manually === 1
                    && (
                      <div className="col-12 mb-2" key={quote.id}>
                        <PreventivassCard requestInfo={requestInfo} key={quote.id} quotation={quote} refresh={refresh} />
                      </div>
                    )}
                </>
              ) : currentQuotes === 'indiretta' ? (
                <>
                  {quote.company_id === null && quote.added_manually !== 1
                    && (
                      <div className="col-12 mb-2" key={quote.id}>
                        <PreventivassCard requestInfo={requestInfo} key={quote.id} quotation={quote} refresh={refresh} />
                      </div>
                    )}
                </>
              ) : ''
            ))}

          </div> */}

          {failedQuotes !== null && failedQuotes.length > 0 && (
            <FailedQuotationsComponent failedQuotes={failedQuotes} />
          )}
        </div>
      </RcQuotesStyles>
    </Layout>
  );
}

export default BackOfficeVehicleQuotes;
